import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CareerService } from '../shared/services/career.service';
import * as AOS from 'aos';

//jquery declaration
declare var $: any;

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.css']
})
export class CareersComponent implements OnInit {

  careerList:any=[];
  constructor(
    private service:CareerService,
    private titleService: Title,
    private renderer: Renderer2,
    private el: ElementRef
  ) { }

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle("Safety Training - SFI Compliance, Inc");
    AOS.init();
    await this.service.getCareerList().then(data=>{      
      console.log(data);
      this.careerList=data;      
    });
    const container = this.el.nativeElement.querySelector('#ziprecruiter-widget-container');

    // ✅ Add first <a> tag
    const link1 = this.renderer.createElement('a');
    link1.href = 'https://www.ziprecruiter.com/c/SFI-Compliance-Inc/Jobs?hiring_company=fc723c9c';
    link1.id = 'jobs_widget_company_link';
    link1.target = '_blank';
    link1.textContent = 'Jobs at SFI Compliance Inc.';
    this.renderer.appendChild(container, link1);

    // ✅ Add <script> tag
    const script = this.renderer.createElement('script');
    script.src = 'https://www.ziprecruiter.com/jobs-widget/v1/fc723c9c?show_posted_days=0';
    script.async = true;
    this.renderer.appendChild(container, script);

    // ✅ Add second <a> tag
    const link2 = this.renderer.createElement('a');
    link2.href = 'https://www.ziprecruiter.com/';
    link2.id = 'jobs_widget_link_split';
    link2.target = '_blank';
    link2.textContent = 'Provided by ZipRecruiter';
    this.renderer.appendChild(container, link2);
  
  }

  ngAfterViewInit(): void {
    const script = this.renderer.createElement('script');
    script.src = 'https://workforcenow.adp.com/mascsr/default/mdf/recwebcomponents/recruitment/main-config/recruitment.js';
    script.type = 'text/javascript';
    this.renderer.appendChild(document.body, script);

    // Optional: Add custom initialization logic if needed
    script.onload = () => {
      console.log('recruitment.js script loaded');
    };
  }

}


  